// extracted by mini-css-extract-plugin
module.exports = {"cover":"AdvertisementSmall_cover__YZ6SE","close":"AdvertisementSmall_close__2pcz2"};